import React, {useContext, useState} from 'react';
import cancel from "../../accets/img/cancel.png";
import good from "../../accets/img/Good.png";
import comment from "../../accets/img/comment.png";
import paper_clip from "../../accets/img/paper_clip.png";
import {Context} from "../../index";
import {useNavigate} from "react-router-dom";
import CreatedMyTaskTabOpen from "./CreatedMyTaskTabOpen";
import CreatedMyTaskTabClose from "./CreatedMyTaskTabClose";

const CreatedMyTaskTab = ({TaskWithFileAndComment, date, catTab, statusTask}) => {

    return (
        <>
            <CreatedMyTaskTabOpen TaskWithFileAndComment={TaskWithFileAndComment} date={date} catTab={catTab} statusTask={statusTask} />
            <CreatedMyTaskTabClose TaskWithFileAndComment={TaskWithFileAndComment} date={date} catTab={catTab} statusTask={statusTask} />
        </>
    );
};

export default CreatedMyTaskTab;